import React, { useState } from 'react'

const OpcionesEspaciadorVertical = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [height, setHeight] = useState(styles?.height || 20)
    return (
        <div className='mb-2'>
            <h4>Tamaño</h4>
            <input type="range" value={height} className="form-range w-100" onChange={(e) => { handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'height' }); setHeight(e.target.value) }} max="200" />
        </div>
    )
}

export default OpcionesEspaciadorVertical